// extracted by mini-css-extract-plugin
export default {"container":"maskDot_container__TgEbu","dotWrapper":"maskDot_dotWrapper__uA5Vh","group":"maskDot_group__jWmnf","dot":"maskDot_dot__91+4p","value":"maskDot_value__TnUyj"};